// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedExtaro300AddOnError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9823 0C7.57051 0 3.99409 2.68629 3.99409 6V7H0V14.5L3.99409 15.5V24H5.99113V6C5.99113 5.1138 6.46471 4.15901 7.53199 3.35736C8.59989 2.55525 10.1667 2 11.9823 2H16.9749V4H13.9793L14.8521 8.6616L11.9824 11.5355L13.3945 12.9497L15.298 11.0434L15.4771 12H20.4697L20.6544 11.0134L22.5879 12.9497L24 11.5355L21.1003 8.63158L21.9675 4H18.9719V0H11.9823ZM17.1345 10H18.8123L19.5612 6H16.3856L17.1345 10ZM1.99704 9H3.99409V13.4384L1.99704 12.9384V9Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" class="svg-fg"/>
</svg>
`;
/**
 * IconMedExtaro300AddOnError is a generated icon component.
 */
let IconMedExtaro300AddOnError = IconMedExtaro300AddOnError_1 = class IconMedExtaro300AddOnError extends IconBaseElement {
    render() {
        return html `${IconMedExtaro300AddOnError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedExtaro300AddOnError.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedExtaro300AddOnError = IconMedExtaro300AddOnError_1 = __decorate([
    customElement('zui-icon-med-extaro-300-add-on-error')
], IconMedExtaro300AddOnError);
export { IconMedExtaro300AddOnError };
